import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import { applicationsService } from "../../services/ApplicationsService";
import { formatDate } from "../../config/Config";
import { AppDB } from "../../App";
import { authenticationService } from "../../services/AuthenticationService";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";

import { Badge } from "primereact/badge";
import { APPLICATION_TYPE_REMOVAL, permissionLookUp } from "../../constants";
import { applicationLocks } from "../../services/ApplicationLocks";
import { createNestablePublicClientApplication } from "@azure/msal-browser";
import { useIsAuthenticated } from "@azure/msal-react";

export const ApplicationTable = ({
	query,
	onShowApplication,
	showSelectAll = false,
	loading = null,
	setLoading,
	isApproved = null,
	loadData = false,
	returnedApplication =false,
}) => {
	const toast = useRef(null);
	var {
		refreshingApplication,
		seRefreshingApplication,
		permission,
		setPermission,
		currrentApplicationScreen,
		userInfo,
		officeOnly,
		isOfficeView
	} = useContext(AppDB);

	console.log(query);
	const [dialogInfo, setDialogInfo] = useState({
		show: false,
		data: []
	});
	var [data, setData] = useState([]);
	const [totalRecords, setTotalRecords] = useState([]);
	const [selectedItems, setSelectedItems] = useState([]);
	var { currrentApplicationScreen } = useContext(AppDB);

	const [filters, setFilters] = useState({
		global: { value: null, matchMode: FilterMatchMode.CONTAINS },
		referenceNumber: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
		idNumber: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
		applicationDate: { value: null, matchMode: FilterMatchMode.CUSTOM },
		"applicationType.name": { value: null, matchMode: FilterMatchMode.EQUALS },
		"applicationStatus.name": { value: null, matchMode: FilterMatchMode.EQUALS }
	});
	const [lazyState, setlazyState] = useState({
		first: 0,
		rows: 10,
		page: 0
	});
	const onPageChange = (event) => {
		setlazyState(event);
	};
	const [showEditCorrectionDialog, setShowEditCorrectionDialog] = useState(false);
	const [currentVoterID, setCurrentVoterID] = useState(null);

	const onApproveAllHandler = async () => {
		var applicationsIDS = selectedItems.map((item) => item?.applicationID);
		const data = {
			applicationIDs: applicationsIDS,
			userID: authenticationService.getCurrentUser().userID,
			reason: "",
			note: "note"
		};
		await setLoading(true);
		// if (transaction === "Accept") {
		var response = await applicationsService.accept(data);
		if (response.success) {
			toast.current.show({
				severity: "success",
				summary: "Success Message",
				detail: "Applications Approved",
				life: 6000
			});
			seRefreshingApplication(!refreshingApplication);
			setDialogInfo({ ...dialogInfo, show: true, data: response.data });
			setSelectedItems([]);
			await setLoading(false);
		} else {
			toast.current.show({
				severity: "error",
				summary: "Error Message",
				detail: response?.message,
				life: 6000
			});
			await setLoading(false);
			seRefreshingApplication(!refreshingApplication);
		}
		// } else {
		// 	response = await applicationsService.reject(data);
		// // }
		// console.log(data)
	};

	const onRejectAllHandler = async () => {
		var applicationsIDS = selectedItems.map((item) => item?.applicationID);
		const data = {
			applicationIDs: applicationsIDS,
			userID: authenticationService.getCurrentUser().userID,
			reason: "",
			note: "note"
		};
		await setLoading(true);
		// if (transaction === "Accept") {
		var response = await applicationsService.reject(data);
		if (response.success) {
			toast.current.show({
				severity: "success",
				summary: "Success Message",
				detail: "Applications Rejected",
				life: 6000
			});
			seRefreshingApplication(!refreshingApplication);
			setDialogInfo({ ...dialogInfo, show: true, data: response.data });
			setSelectedItems([]);
			await setLoading(false);
		} else {
			toast.current.show({
				severity: "error",
				summary: "Error Message",
				detail: response?.message,
				life: 6000
			});
			await setLoading(false);
			seRefreshingApplication(!refreshingApplication);
		}
		// } else {
		// 	response = await applicationsService.reject(data);
		// // }
		// console.log(data)
	};

	const paginatorRight = () => {
		return (
			<div>
				{permission?.actions?.includes(permissionLookUp.Approve) && permission?.Approve == true && showSelectAll == true && (
					<Button
						loading={loading}
						disabled={selectedItems.length === 0}
						onClick={onApproveAllHandler}
						className="p-button-primary mr-2"
						icon="pi pi-check"
						type="button"
						label="Approve"
						size="small"
					/>
				)}

				{(currrentApplicationScreen === "registration" ||
					currrentApplicationScreen === "migrations" ||
					currrentApplicationScreen === "amendments" ||
					currrentApplicationScreen === "registration" ||
					currrentApplicationScreen === "suspensions" ||
					currrentApplicationScreen === "re-instatements" ||
					currrentApplicationScreen === "removals" ||
					currrentApplicationScreen === "corrections") &&
					permission?.actions?.includes(permissionLookUp.Reject) &&
					permission?.Reject == true &&
					showSelectAll == true && (
						<Button
							loading={loading}
							disabled={selectedItems.length === 0}
							onClick={onRejectAllHandler}
							className="p-button-danger"
							icon="pi pi-times"
							type="button"
							label="Reject"
							size="small"
						/>
					)}
			</div>
		);
	};

	// const paginatorRight = () => {
	// 	if (permission?.actions?.includes(permissionLookUp.Approve) && permission?.Approve == true && showSelectAll == true) {
	// 		return (
	// 			<>
	// 				<Button
	// 					loading={loading}
	// 					disabled={selectedItems.length === 0}
	// 					onClick={onApproveAllHandler}
	// 					className="p-button-primary ml-2"
	// 					icon="pi pi-check"
	// 					type="button"
	// 					label="Approve"
	// 					size="small"
	// 				/>
	// 			</>
	// 		);
	// 	}
	// 	return "";
	// };

	const registrationCentreTemplate = (rowData) => {
		if (rowData.applicationTypeID == 1) {
			return rowData.registration.village.registrationCentre;
		}

		return "";
	};

	const villageTemplate = (rowData) => {
		// if (rowData.applicationTypeID == 1) {
		// 	return rowData.registration.village.name;
		// }

		return `${rowData?.village?.code}-${rowData?.village?.name}`;
	};

	useEffect(() => {
		var queryObject = { ...query };
		queryObject.pageIndex = 1;
		queryObject.pageSize = lazyState.rows * (lazyState.page + 1);
		if ((queryObject.allowNullDelimitation || queryObject.delimitationID !== "") && loadData === true) {
			setLoading(true);
			if (returnedApplication && !isOfficeView) {
				queryObject.userID = userInfo?.data?.userID;
				queryObject.officeOnly = officeOnly;
				queryObject.isOfficeView = isOfficeView;
				// keep the delimitation values
				queryObject.delimitationID = queryObject?.delimitationID;
				queryObject.delimitationLevelID = queryObject?.delimitationLevelID;
			} else if (returnedApplication && isOfficeView) {
				queryObject.userID = userInfo?.data?.userID;
				queryObject.isOfficeView = isOfficeView;
				queryObject.officeOnly = !officeOnly;
				// clear delimitations only when needed
				queryObject.delimitationID = "";
				queryObject.delimitationLevelID = "";
			}

			applicationsService
				.getAll(queryObject)
				.then((_data) => {
					setLoading(false);
					setData([..._data.applications]);
					setTotalRecords(data.count);
				})
				.catch((error) => {
					console.error("Error fetching application:", error);
					setLoading(false);
				});
		}
	}, [lazyState, query, refreshingApplication]);
	return (
		<>
			<Toast ref={toast} />

			<Dialog
				header={`Results`}
				visible={dialogInfo.show}
				style={{ width: "500px" }}
				onHide={() => setDialogInfo({ ...dialogInfo, show: false })}
			>
				<DataTable value={dialogInfo.data} paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}>
					<Column field="message" header="#" body={(_, row) => <b>{row.rowIndex + 1}</b>}></Column>
					<Column field="idNumber" header="ID Number"></Column>
					<Column
						field="status"
						header="Status"
						body={(e) =>
							e.success ? <Badge value="success" severity="success"></Badge> : <Badge value="failed" severity="danger"></Badge>
						}
					></Column>
					<Column field="message" header="Message"></Column>
				</DataTable>
			</Dialog>

			<DataTable
				first={lazyState.first}
				size="small"
				scrollable={true}
				value={data}
				loading={loading}
				dataKey="applicationID"
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
				emptyMessage="No data found."
				resizableColumns
				columnResizeMode="expand"
				selectionMode="checkbox"
				onSelectionChange={(e) => setSelectedItems(e.value)}
				selection={selectedItems}
				selectionPageOnly={true}
				filters={filters}
				globalFilterFields={["referenceNumber", "idNumber", "applicationDate", "applicationType.name", "applicationStatus.name"]}
				rows={lazyState.rows}
				rowsPerPageOptions={[10, 20, 50]}
				totalRecords={totalRecords}
				onPage={onPageChange}
				paginator={true}
				paginatorRight={paginatorRight}
				paginatorLeft={<></>}
				// paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
				// paginatorRight={paginatorRight}
			>
				{showSelectAll && <Column selectionMode="multiple"></Column>}

				{/* <Column field="referenceNumber" header="Reference No." sortable></Column> */}

				<Column field="idNumber" header="National ID" sortable filter></Column>
				<Column
					field={isApproved == null ? "applicationDate" : "updatedDate"}
					header={
						<>
							{isApproved === null && "Application Date"}
							{isApproved === true && "Approved Date"}
							{isApproved === false && "Rejected Date"}
						</>
					}
					sortable
					body={(rowData) => formatDate((isApproved == null ? rowData.applicationDate : rowData.updatedDate)?.split(" ")[0])}
				/>
				{/* <Column field="applicationChannel.name" header="Channel" sortable /> */}
				{/* <Column field="applicationType.name" header="Type" sortable /> */}

				{/* <Column field="applicationStatus" header="Status" sortable /> */}
				{/* <Column field="village.registrationCentre" header="Voting Station" body={registrationCentreTemplate} sortable /> */}
				<Column field="village.code" header="Village" body={villageTemplate} sortable />
				{["removals", "re-instatements"].includes(currrentApplicationScreen) && (
					<Column
						field="source"
						header="Initiated By"
						sortable
						body={(row) => (
							<>
								{currrentApplicationScreen === "removals" && <>{row.removal.applicationSource}</>}
								{currrentApplicationScreen === "re-instatements" && <>{row.reinstatement.applicationSource}</>}
							</>
						)}
					></Column>
				)}
				<Column
					field="actions"
					header="Actions"
					body={(rowData) => (
						<>
							{/* View Application */}
							<Button
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon="pi pi-eye"
								tooltip="View Application"
								className="p-button-primary p-button-rounded mr-2"
								onClick={() => {
									console.log(rowData);
									setLoading(true);
									applicationsService.getByID(rowData.applicationID).then(() => {
										onShowApplication(rowData);
										setLoading(false);
									});
								}}
							/>
						</>
					)}
				/>
			</DataTable>
		</>
	);
};
